/** @jsx jsx */

import React, { ReactElement, useContext, useRef, useEffect } from 'react';
import { css, jsx } from '@emotion/core';
import { motion } from 'framer-motion';
import { colors } from 'styles/variables';
import { interactionContext as _interactionContext } from './interactionContext';
import isiOS from 'services/isiOS';
import isEDGE from 'services/isEDGE';
import isAppleComputerInc from 'services/isAppleComputerInc';

const { lPink, lGrey0, lGrey1, lGrey2 } = colors;

const imgTransition = currentIndex => {
  // console.log(currentIndex);

  return {
    initial: {},
    go: {
      transform: `translateX(-${100 * currentIndex}%)`,
      transition: {
        duration: 0.35,
        type: 'spring',
        stiffness: 260,
        damping: 20,
      },
    },
  };
};

const CarouselSlide = ({
  index,
  currentIndex,
  animate,
  imgHeight,
  carouselColor,
  carouselTextColor,
  animation,
  slide,
}) => {
  const img = slide.props.children[0];
  const text = slide.props.children[1];

  const slideRef = useRef(null);

  // isiOS()
  return isAppleComputerInc() ? (
    <li
      ref={slideRef}
      css={css`
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        width: 100%;
        list-style-type: none;

        opacity: ${currentIndex === index ? 1 : 0};
        transition: opacity 0.35s;

        transform: translateX(-${100 * currentIndex}%);
      `}
      tabIndex={-1}
      aria-hidden={currentIndex !== index}
    >
      <div
        css={css`
          height: ${imgHeight}px;
          padding: ${window.dev() ? '5px' : '0px'};
        `}
      >
        {img}
      </div>
      <div
        css={css`
          position: relative;
          display: flex;
          align-items: center;
          width: 100%;
          // height: ${currentIndex === index ? 'auto' : 0};
          text-align: center;
          padding: ${window.dev() ? '3px 5px' : '13px 7px'};
          // overflow: hidden;
          word-break: break-word;
          * div {
            ${!window.dev() && `padding: 5px 10px;`}
            color: ${carouselTextColor};
          }

          // background: red;
        `}
      >
        {text}
      </div>
    </li>
  ) : (
    <motion.li
      ref={slideRef}
      // key={`slide${index}_${currentIndex}`}
      css={css`
        display: flex;
        flex-direction: column;
        flex-shrink: 0;

        width: 100%;
        list-style-type: none;
      `}
      animate={{ transform: `translateX(-${100 * currentIndex}%)` }}
      transition={
        // animate
        //   ? {
        //       duration: 0.35,
        //       type: 'spring',
        //       stiffness: 260 / 1.5,
        //       damping: 19,
        //     }
        //   : {
        //       duration: 0,
        //     }

        {
          natural: {
            duration: 0.35,
            type: 'spring',
            stiffness: 260 / 1.5,
            damping: 19,
          },
          smooth: {
            duration: 0.35,
            // type: 'spring',
            // stiffness: 260 / 1.5,
            // damping: 19,
          },
          none: {
            duration: 0,
          },
        }[animation]
      }
      // variants={imgTransition()}
      // initial="initial"
      // animate="go"
      tabIndex={-1}
      aria-hidden={currentIndex !== index}
    >
      <div
        css={css`
          height: ${imgHeight}px;
          padding: ${window.dev() ? '5px' : '0px'};
        `}
      >
        {img}
      </div>
      <motion.div
        css={css`
          position: relative;
          display: flex;
          align-items: center;
          width: 100%;
          height: ${currentIndex === index ? 'auto' : 0};
          text-align: center;
          padding: ${window.dev() ? '3px 5px' : '13px 7px'};

          // * {
          //   width: 100%;
          // }

          overflow: hidden;

          // this fricken thing !!!
          word-break: break-word;

          // if we bring this in. it needs to have some conditional logic
          // to recognize its context
          // list-style-position: inside;

          ${currentIndex === index && 'transition: height 0.2s;'}
          transition: height 0.2s;

          * div {
            ${!window.dev() && `padding: 5px 10px;`}
            color: ${carouselTextColor};
          }
        `}
        // removed
        // animate={{ opacity: currentIndex === index ? 1 : 0 }}
        // transition={
        //   currentIndex === index
        //     ? {
        //         duration: 0.25,
        //         delay: 0.2,
        //       }
        //     : {
        //         duration: 0,
        //       }
        // }
      >
        {text}
      </motion.div>
    </motion.li>
  );
};

export default CarouselSlide;
